import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  LMContextService,
  LMDrillService,
  LMLoggerService,
  LMConfigurationService,
  LMRelatedReportService
} from '@services/index';
import { LMThemeService } from '@banner/lm-theme.service';

@Injectable()
export class LMToolbarServiceAdapter {
  constructor(
    public http: HttpClient,
    public lmContextService: LMContextService,
    public lmDrillService: LMDrillService,
    public lmLoggerService: LMLoggerService,
    public lmRelatedReportService: LMRelatedReportService,
    public lmThemeService: LMThemeService,
    public lmConfigurationService: LMConfigurationService
  ) {}
}
